// extracted by mini-css-extract-plugin
var _1 = "Credentials-module_attribute__qlVuUq";
var _2 = "Credentials-module_attribute_link__nIN6Vx";
var _3 = "Credentials-module_attribute_list__OdYvyE";
var _4 = "Credentials-module_attribute_name__eaone8";
var _5 = "Credentials-module_attribute_value__WKoj5t";
var _6 = "Credentials-module_avatar__MliuJF";
var _7 = "Credentials-module_avatar_image__BYC3Zv";
var _8 = "Credentials-module_avatar_label__Ir5sry";
var _9 = "Credentials-module_avatar_name__axPWmY";
var _a = "Credentials-module_avatar_role__iW_T59";
var _b = "Credentials-module_span2__vj2lUG";
export { _1 as "attribute", _2 as "attribute_link", _3 as "attribute_list", _4 as "attribute_name", _5 as "attribute_value", _6 as "avatar", _7 as "avatar_image", _8 as "avatar_label", _9 as "avatar_name", _a as "avatar_role", _b as "span2" }
